import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mock/mockData';
import { ContactForm } from '../components/ContactForm';
import { SEO } from '../components/SEO';

const contactItems = [
  { label: 'Telefon', icon: Phone, render: () => (
    <a href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`} className="text-sm font-medium text-gray-900 hover:text-blue-700 transition-colors">
      {companyInfo.phones[0]}
    </a>
  )},
  { label: 'Elektron ünvan', icon: Mail, render: () => (
    <a href={`mailto:${companyInfo.email}`} className="text-sm font-medium text-gray-900 hover:text-blue-700 transition-colors break-all">
      {companyInfo.email}
    </a>
  )},
  { label: 'Ofis ünvanı', icon: MapPin, render: () => (
    <p className="text-sm font-medium text-gray-900">{companyInfo.address}</p>
  )},
  { label: 'İş saatları', icon: Clock, render: () => (
    <p className="text-sm font-medium text-gray-900">B.e – Cümə, 09:00 – 18:00</p>
  )}
];

export const ContactPage = () => {
  return (
    <div className="bg-white">
      <SEO
        title="Əlaqə məlumatları | İDK BOKT"
        description="İDK BOKT ilə əlaqə saxlayın. Telefon, e-mail və ünvan məlumatları, iş saatları və onlayn sorğu formu."
        path="/elaqe"
      />
      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 font-serif-display">Bizimlə əlaqə</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Suallarınız üçün birbaşa əlaqə saxlayın.
          </p>
        </div>
      </section>

      <section className="py-10 pb-24">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14">
            {/* Form */}
            <div className="lg:col-span-3">
              <Card className="border border-gray-200">
                <CardContent className="pt-6">
                  <ContactForm />
                </CardContent>
              </Card>
            </div>

            {/* Contact details + Map */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-5">Əlaqə məlumatları</h3>
                <ul className="divide-y divide-gray-200">
                  {contactItems.map(({ label, icon: Icon, render }) => (
                    <li key={label} className="flex items-start gap-4 py-4">
                      <Icon className="h-5 w-5 text-blue-700 flex-shrink-0 mt-0.5" />
                      <div className="min-w-0">
                        <p className="text-xs text-gray-500 mb-0.5">{label}</p>
                        {render()}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl overflow-hidden border border-gray-200">
                <iframe
                  title="İnkişafa Dəstək Kreditləri BOKT ofisi"
                  src="https://www.google.com/maps?q=Əhməd+Rəcəbli+29,+Nərimanov,+Bakı,+Azərbaycan&output=embed"
                  width="100%"
                  height="240"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
